import './App.scss';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Programs from './components/Programs/Programs';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer';
import Error404 from './components/Error404/Error404';
import ScrollToTop from './components/Utils/ScrollToTop';
import UserDashboard from './components/UserDashboard/UserDashboard';
import Signin from './components/Authorization/Signin';
import { AuthProvider } from './context/AuthProvider';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <ScrollToTop/>
          <Navigation/>

          <main>
            <Routes>
              <Route path='/' element={<Navigate to='/products'/>}/>
              <Route path='/products' element={<Programs/>}/>
              <Route path='/products/:product' element={<Programs/>}/>
              <Route path='/user/dashboard' element={<UserDashboard/>}/>
              <Route path='/user/signin' element={<Signin/>}/>
              <Route path='*' element={<Error404/>}/>
            </Routes>
          </main>

          <Footer/>



          <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
